import {messages} from '@smartmixin/i18n';
import type {MessageDescriptor} from 'react-intl';

export type StationTab = {
  value: 'dashboard' | 'history' | 'forecast' | 'analysis';
  /** The path under `/app/stations/:id`; '' for the Dashboard itself. */
  segment: string;
  label: MessageDescriptor;
};

/**
 * The station page's tabs, in order. The tab bar and the breadcrumbs both
 * read their labels from here, so a crumb can never name a tab differently
 * (the Charts tab's crumb once said "History", in English, in every locale).
 */
export const STATION_TABS: readonly StationTab[] = [
  {value: 'dashboard', segment: '', label: messages.dashboard.dashboard},
  {value: 'history', segment: 'history', label: messages.charts.charts},
  {value: 'forecast', segment: 'forecast', label: messages.common.forecast},
  {value: 'analysis', segment: 'analysis', label: messages.reports.analysis},
];
